import * as React from "react";
import * as ReactQuery from "react-query";

const queryClient = new ReactQuery.QueryClient();

export const ReactQueryClientProvider: React.FunctionComponent = (props) => {
  return (
    <ReactQuery.QueryClientProvider client={queryClient}>
      {props.children || []}
    </ReactQuery.QueryClientProvider>
  );
};

export const useReactQueryClient = ReactQuery.useQueryClient;
